// extracted by mini-css-extract-plugin
module.exports = {"searchButton":"Search_searchButton__14Qo3","magnifyingGlassIcon":"Search_magnifyingGlassIcon__uyNw6"};